'use client';

import { cn } from '../../utils/cn/cn';

type BypassTargetButtonProps = {
  /**
   * The id of the anchor element.
   */
  id: string;
  className?: string;
};

export const BypassTargetButton = ({ id, className }: BypassTargetButtonProps) => (
  <button
    id={id}
    type="button"
    aria-hidden
    className={cn('absolute bottom-0 h-0 w-0 overflow-hidden', className)}
    tabIndex={-1}
  />
);
